import { Button, Dropdown, Menu } from 'antd';
import PDFDownloadModal from './PDFDownloadModal';
import { useDisclosure } from '@/hooks';
import XMLDownloadModal from './XMLDownloadModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export default function InvoiceDownloadFiles() {
  const [pdfOpen, pdfAction] = useDisclosure();
  const [xmlOpen, xmlAction] = useDisclosure();

  const hasXMLPermission = hasPermissions([
    Authorities.FISCAL_INVOICE_DOWNLOAD_XML,
  ]);

  const menu = (
    <Menu>
      <Menu.Item onClick={pdfAction.open}>Baixar PDFs</Menu.Item>
      <Menu.Item disabled={!hasXMLPermission} onClick={xmlAction.open}>
        Baixar XMLs
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu}>
        <Button>Baixar arquivos</Button>
      </Dropdown>

      <PDFDownloadModal opened={pdfOpen} onClose={pdfAction.close} />
      <XMLDownloadModal opened={xmlOpen} onClose={xmlAction.close} />
    </>
  );
}
